import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useQuery } from "@apollo/client";
import { GET_TOWERS_QUERY } from "../../graphql/queries/towers";
import Loader from "../loader/loader";
import hasValue from "../../utils/hasValue";
import stringifyArray from "../../utils/arrayToString";
import DisplaySelect from "../display-select/display-select";
import MultiSelect from "../multi-select/multi-select";
import { METER_TELEMETRY_STATES } from "../../utils/meter-telemetry-states";
import CustomSelect from "../custom-select/custom-select";

const TowersFilters = ({
  onFilter,
  onApplyFilters,
  setAppliedFilters,
  appliedFilters,
}) => {
  const { handleSubmit, control, setValue } = useForm({
    defaultValues: {
      status: appliedFilters.status,
      towers: appliedFilters.towers,
    },
  });

  const [towersData, setTowersData] = useState([]);
  const getTowersResponse = useQuery(GET_TOWERS_QUERY, {
    fetchPolicy: "cache-and-network",
  });

  useEffect(() => {
    if (getTowersResponse?.data) {
      const data = getTowersResponse.data.towers.items.map((t) => ({
        value: t.zonkeId,
        label: t.zonkeId,
      }));
      setTowersData(data);
    }
  }, [getTowersResponse]);

  useEffect(() => {
    setValue("status", appliedFilters.status);
    setValue("towers", appliedFilters.towers);
  }, [appliedFilters, setValue]);

  if (getTowersResponse?.loading) {
    return <Loader sizeClass={"size--medium"} />;
  }

  if (getTowersResponse?.error) {
    return (
      <div className="basic-modal">
        <div className="basic-modal__header">
          <h3>Error Loading Filters</h3>
        </div>
        <div className="basic-modal__body">
          <div
            className="input-container__error"
            style={{
              padding: "20px",
              backgroundColor: "#ffebee",
              border: "1px solid #ef5350",
              borderRadius: "4px",
              color: "#c62828",
            }}
          >
            {getTowersResponse?.error?.message ||
              "Failed to load tower options. Please try again."}
          </div>
          <div className="basic-modal__footer">
            <button onClick={onFilter} className="button button--secondary">
              Close
            </button>
          </div>
        </div>
      </div>
    );
  }

  const onSubmit = (data) => {
    setAppliedFilters({
      status: data.status,
      towers: data.towers,
    });
    onFilter();
  };

  return (
    <div className="basic-modal">
      <div className="basic-modal__header">
        <h3>Filter Towers</h3>
        {hasValue(appliedFilters) && (
          <div className="basic-modal__sub-header">
            Applied: filters:
            <div className="basic-modal__sub-header-text--bold">
              {stringifyArray(appliedFilters.status)},{" "}
              {stringifyArray(appliedFilters.towers)}
            </div>
          </div>
        )}
      </div>
      <div className="basic-modal__body">
        <form onSubmit={handleSubmit(onSubmit)} className="basic-modal__form">
          <div className="input-container">
            <DisplaySelect placeholder={"Status"} name={"status"} errors={{}}>
              <Controller
                name={"status"}
                control={control}
                render={({ field }) => (
                  <MultiSelect
                    field={field}
                    options={Object.entries(METER_TELEMETRY_STATES).map(
                      ([value, label]) => ({
                        value,
                        label,
                      })
                    )}
                  />
                )}
              />
            </DisplaySelect>
          </div>

          <div className="input-container">
            <DisplaySelect placeholder={"Tower"} name={"towers"} errors={{}}>
              <Controller
                name={"towers"}
                control={control}
                render={({ field }) => (
                  <CustomSelect
                    options={towersData}
                    field={field}
                    isMulti={true}
                    isSearchable={true}
                  />
                )}
              />
            </DisplaySelect>
          </div>

          <div className="basic-modal__footer">
            <button
              type="button"
              onClick={onFilter}
              className="button button--secondary"
            >
              Cancel
            </button>
            <button type="submit" className="button button--primary">
              Apply
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default TowersFilters;
